import React from 'react';
import PropTypes from 'prop-types';
import {Form, InputGroup, FormControl, Button, Modal} from 'react-bootstrap';
import couponsAPI from '../../../../_api/coupons';

class BuyOneClickButtonModal extends React.Component {
  static propTypes = {
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    price: PropTypes.number.isRequired,
    shopoffers_type: PropTypes.number.isRequired,
    currency: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
  };

  state = {
    show: false,
    showCouponFiled: false,
    couponList: [],
    couponFiledValue: '',
    couponFiledError: null,
    couponDiscount: null,
  };

  resetCoupon = (showCouponFiled=false) => {
    this.setState({
      showCouponFiled: showCouponFiled,
      couponFiledValue: '',
      couponFiledError: null,
      couponDiscount: null,
    });
  };

  handleClose = () => { this.setState({show: false}); this.resetCoupon() };
  handleShow = async () => {
    this.setState({ show: true });
    const response = await couponsAPI.getAvailableList(this.props.id, this.props.shopoffers_type)
    if (response) this.setState({ couponList: response })
  };

  handleCheckboxChange = (event) => {
    this.resetCoupon(event.currentTarget.checked);
  };

  handleCheckCouponClick = async () => {
    try{
      let response = await couponsAPI.validate(this.state.couponFiledValue, this.props.shopoffers_type);
      if (response) {
        this.setState({
          couponFiledError: null,
          couponDiscount: response.value
        });
      }
    } catch (e) {
      this.setState({
        couponFiledError: e.message,
        couponDiscount: null
      });
    }
  };

  handleCouponLinkClick = (event) => {
    event.preventDefault();
    let id = parseInt(event.currentTarget.getAttribute('data-id'));
    let coupon = this.state.couponList.filter(item => item.id === id)[0];
    this.setState({
      couponFiledValue: coupon.code,
      couponFiledError: null,
      couponDiscount: coupon.value
    });
  };

  handleCouponChange = (event) => {
    let code = event.currentTarget.value.trim().toUpperCase();
    this.setState({ couponFiledValue: code });
  };

  handleBuyClick = (event) => {
    event.currentTarget.setAttribute('disabled', 'disabled');
    this.props.onClick(this.state.couponFiledValue);
  };

  render() {
    const coupons = this.state.couponList.map(item => <a href='#' className='mr-2'
                                                         data-id={ item.id }
                                                         onClick={ this.handleCouponLinkClick }>{ item.code }</a>);
    let price = '';
    if (this.state.couponDiscount){
      let discount_price = parseFloat((this.props.price - this.props.price * this.state.couponDiscount / 100).toFixed(2));
      price = <>
        <span className="card-price__without-discount mr-2">{ this.props.currency }{ this.props.price }</span>
        <span className="card-price__with-discount">{ this.props.currency }{ discount_price }</span>
      </>;
    } else {
      price = <span className='font-weight-bold'>{ this.props.currency }{ this.props.price }</span>;
    }
    let checkButtonVariant = 'outline-secondary';
    if (this.state.couponDiscount) checkButtonVariant = 'outline-success';
    else if (this.state.couponFiledError) checkButtonVariant = 'outline-danger';

    return (
      <>
        <Button size="sm" variant='outline-dark' className='mr-2' title={ gettext('Купить в один клик') }
                onClick={ this.handleShow }>
          <span className="icon icon-credit-card"></span> { gettext('Купить') }
        </Button>

        <Modal show={ this.state.show } onHide={ this.handleClose }>
          <Modal.Header closeButton>
            <Modal.Title>{ gettext('Купить в один клик') }<br/>
              <small>{ this.props.title }</small></Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>{ gettext('Цена') }: { price }</p>
            <Form>
              <Form.Group controlId="formCheckbox">
                <Form.Check type="checkbox" label={ gettext('У меня есть промокод') }
                            onChange={ this.handleCheckboxChange }/>
              </Form.Group>
              { this.state.showCouponFiled && <>
                <InputGroup className="mb-3">
                  <FormControl
                    placeholder={ gettext('Промокод') }
                    aria-label={ gettext('Промокод') }
                    aria-describedby="coupon-addon"
                    value={ this.state.couponFiledValue }
                    onChange={ this.handleCouponChange }
                    isValid={ this.state.couponDiscount }
                    isInvalid={ this.state.couponFiledError }
                  />
                  <InputGroup.Append>
                    <Button variant={ checkButtonVariant }
                            onClick={ this.handleCheckCouponClick }
                            isValid={ this.state.couponDiscount }
                            isInvalid={ this.state.couponFiledError }>
                      { gettext('Проверить') }
                    </Button>
                  </InputGroup.Append>
                </InputGroup>
                { coupons.length > 0 && <p className='small my-0'>{ coupons }</p> }
                { (this.state.couponFiledError === null && this.state.couponDiscount === null) &&
                <Form.Text className="text-muted">
                  {gettext('Наши промокоды вы можете найти в наших рассылках, на наших страницах в социальных сетях, а также у партнеров.')}
                </Form.Text> }
                { this.state.couponFiledError &&
                  <Form.Text className="text-danger">
                    { gettext('Неверный код.') } { this.state.couponFiledError }
                  </Form.Text> }
                { this.state.couponDiscount &&
                  <Form.Text className="text-success">
                    { gettext('Ваш промокод верен.') } { gettext('Скидка по промокоду:') } { this.state.couponDiscount }%
                  </Form.Text> }
              </>}
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={ this.handleClose }>
              { gettext('Отменить') }
            </Button>
            <Button variant="primary" onClick={ this.handleBuyClick }>
              { gettext('Перейти к оплате') }
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}

export default BuyOneClickButtonModal;